// GlobalEventManager.js
class GlobalEventManager {
  constructor() {
    this.eventsMap = {};
  }

  addEvent(eventName, handler, context) {
    if (!this.eventsMap[eventName]) {
      this.eventsMap[eventName] = [];
      window.addEventListener(eventName, this.trigger.bind(this, eventName));
    }

    this.eventsMap[eventName].push({ handler, context });
  }

  trigger(eventName, event) {
    if (this.eventsMap[eventName]) {
      this.eventsMap[eventName].forEach(listener => {
        listener.handler.call(listener.context, event);
      });
    }
  }

  removeEvent(eventName, context) {
    if (!this.eventsMap[eventName]) return;

    this.eventsMap[eventName] = this.eventsMap[eventName].filter(
      listener => listener.context !== context
    );

    // If there are no listeners, we remove the global handler
    if (this.eventsMap[eventName].length === 0) {
      window.removeEventListener(eventName, this.trigger.bind(this, eventName));
      delete this.eventsMap[eventName];
    }
  }

  removeAllEvents(context) {
    Object.keys(this.eventsMap).forEach(eventName => {
      this.removeEvent(eventName, context);
    });
  }
}

export default new GlobalEventManager();
